import { benefits } from '../../data/landingData';
import { 
  Heart, Shield, Target, Sparkles, Brain, Compass, 
  Users, Handshake, TreePine 
} from 'lucide-react';

const iconMap = [
  Heart, Shield, Target, Sparkles, Brain, 
  Compass, Users, Handshake, TreePine
];

export const Benefits = () => {
  return (
    <section 
      id="benefits" 
      className="py-24 px-6 bg-[#111111]"
      data-testid="benefits-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.2em] text-xs font-bold mb-4">
            Transform Your Life
          </p>
          <h2 className="font-cormorant text-4xl md:text-5xl font-medium text-white mb-4">
            What You'll Gain
          </h2>
          <p className="text-zinc-400 font-manrope max-w-2xl mx-auto">
            This transformative experience will equip you with lasting tools for growth
          </p>
        </div>

        {/* Benefits grid - Bento style */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[index];
            const isLarge = index === 0 || index === 4;
            
            return (
              <div
                key={index}
                className={`group p-8 rounded-2xl bg-[#0A0A0A] border border-white/5 hover:border-[#D4AF37]/30 transition-all hover:-translate-y-1 ${
                  isLarge ? 'md:col-span-2 lg:col-span-1' : ''
                }`}
                data-testid={`benefit-${index}`}
              >
                <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center mb-6 group-hover:bg-[#D4AF37]/20 transition-colors">
                  <Icon className="w-6 h-6 text-[#D4AF37]" />
                </div>
                <h3 className="font-manrope font-semibold text-xl text-white mb-3">
                  {benefit.title}
                </h3>
                <p className="text-zinc-500 font-manrope leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
